import React from "react";
import { Select, ConfigProvider } from "antd";
import "./styles.scss";

const SelectComponent = ({
  value,
  options,
  onChange,
  title,
  placeholder,
  width,
  mode,
  error,
  defaultValue,
  name,
  className = "",
  ...props
}) => {
  return (
    <div
      className={`select-container ${className}`}
      style={{ width: width || "100%" }}
    >
      {title && <div className="select-title">{title}</div>}

      <ConfigProvider renderEmpty={() => "データがありません"}>
        <Select
          defaultValue={defaultValue}
          name={name}
          mode={mode}
          className="responsive-select"
          style={{
            width: "100%",
            border: error ? "1px solid red" : undefined,
            borderRadius: 6,
          }}
          onChange={onChange}
          value={value}
          options={options}
          placeholder={placeholder || "選択"}
          {...props}
        />
      </ConfigProvider>

      {error && <span className="select-error-message">{error}</span>}
    </div>
  );
};

export default SelectComponent;